<template>
  <div class="signature-pad">
    <canvas ref="canvas" @mousedown="startDrawing" @mousemove="draw" @mouseup="stopDrawing" @mouseleave="stopDrawing"
            @touchstart.prevent="startDrawing" @touchmove.prevent="draw" @touchend.prevent="stopDrawing"></canvas>
    <div class="actions">
      <el-button size="small" @click="clear">清空</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignaturePad",
  props: {
    value: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 200,
    },
    lineWidth: {
      type: Number,
      default: 2,
    },
    lineColor: {
      type: String,
      default: "#000000",
    },
  },
  data() {
    return {
      isDrawing: false,
      lastX: 0,
      lastY: 0,
    };
  },
  mounted() {
    this.initCanvas();
    if (this.value) {
      this.loadImage(this.value);
    }
  },
  methods: {
    initCanvas() {
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");
      canvas.width = this.width;
      canvas.height = this.height;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.lineWidth = this.lineWidth;
      ctx.strokeStyle = this.lineColor;
    },
    getCoordinates(event) {
      const canvas = this.$refs.canvas;
      const rect = canvas.getBoundingClientRect();
      let clientX, clientY;

      if (event.touches && event.touches.length > 0) {
        clientX = event.touches[0].clientX;
        clientY = event.touches[0].clientY;
      } else {
        clientX = event.clientX;
        clientY = event.clientY;
      }

      return {
        x: clientX - rect.left,
        y: clientY - rect.top,
      };
    },
    startDrawing(event) {
      this.isDrawing = true;
      const coords = this.getCoordinates(event);
      this.lastX = coords.x;
      this.lastY = coords.y;
    },
    draw(event) {
      if (!this.isDrawing) return;

      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");
      const coords = this.getCoordinates(event);

      // 检查坐标是否在 canvas 范围内
      if (coords.x < 0 || coords.x > canvas.width || coords.y < 0 || coords.y > canvas.height) {
        return;
      }

      ctx.beginPath();
      ctx.moveTo(this.lastX, this.lastY);
      ctx.lineTo(coords.x, coords.y);
      ctx.stroke();

      this.lastX = coords.x;
      this.lastY = coords.y;
    },
    stopDrawing() {
      if (this.isDrawing) {
        this.isDrawing = false;
        this.$emit("input", this.$refs.canvas.toDataURL());
      }
    },
    clear() {
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.$emit("input", "");
    },
    loadImage(url) {
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.onload = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      };
      img.src = url;
    },
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.loadImage(newVal);
      } else {
        this.clear();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.signature-pad {
  display: flex;
  flex-direction: column;
  align-items: center;

  canvas {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fff;
    cursor: crosshair;
    touch-action: none;
  }

  .actions {
    margin-top: 10px;
  }
}
</style>
